// extracted by mini-css-extract-plugin
export default {"table":"SessionHistory_table__3q2s9"};